import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeSaleDateCommand extends BaseCommand {
  CommandName = "ChangeSaleDate";
  Command: { Value: string };
  constructor(sessionId: string, operationId: string, value: string) {
    super(sessionId, operationId);
    this.Command = { Value: value };
  }
}
